/* Template Name: Jobstack - Job Portal Tailwind CSS Template
   Author: Shreethemes
   Email: support@shreethemes.in
   Website: https://shreethemes.in
   Version: 1.0.0
   Created: March 2023
   File Description: Common JS file of the template(plugins.init.js)
*/


/*********************************/
/*         INDEX                 */
/*================================
 *     01.  Tiny Slider          *
 *     02.  Data Counter         *
 *     03.  Tobii lightbox       * (For Portfolio pages)
 *     04.  Back Button          *
 *     05.  Components           *
 *          1. Accordions        *
 *     06.  Choices Js           *
 *     07.  Maintenance Js       * (For Maintenance Page)
 *     08.  Countdown Js         * (For Comingsoon Page)
 *     09.  Upload Profile       *
 ================================*/

//=========================================//
/*            01) Tiny slider              */
//=========================================//
if(document.getElementsByClassName('tiny-five-item').length > 0) {
    var slider = tns({
        container: '.tiny-five-item',
        controls: true,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        controlsText: ['<i class="mdi mdi-chevron-left "></i>', '<i class="mdi mdi-chevron-right"></i>'],
        nav: false,
        speed: 400,
        gutter: 0,
        responsive: {
            1025: {
                items: 5
            },

            992: {
                items: 4
            },

            767: {
                items: 3
            },

            425: {
                items: 1
            },
        },
    });
};

//=========================================//
/*/*            02) Data Counter           */
//=========================================//

try {
    const counter = document.querySelectorAll('.counter-value');
    const speed = 2500; // The lower the slower

    counter.forEach(counter_value => {
        const updateCount = () => {
            const target = +counter_value.getAttribute('data-target');
            const count = +counter_value.innerText;

            // Lower inc to slow and higher to slow
            var inc = target / speed;

            if (inc < 1) {
                inc = 1;
            }

            // Check if target is reached
            if (count < target) {
                // Add inc to count and output in counter_value
                counter_value.innerText = (count + inc).toFixed(0);
                // Call function every ms
                setTimeout(updateCount, 1);
            } else {
                counter_value.innerText = target;
            }
        };

        updateCount();
    });
} catch (err) {

}


//=========================================//
/*/*            03) Tobii lightbox         */
//=========================================//

try {
    const tobii = new Tobii()
} catch (err) {

}

//=========================================//
/*/*            04) Back Button            */
//=========================================//
document.getElementsByClassName("back-button")[0]?.addEventListener("click", (e)=>{
    if (document.referrer !== "") {
        e.preventDefault();
        window.location.href = document.referrer;
      }
})

//=========================================//
/*            05) Components               */
//=========================================//

//********1) Accordions********/
var accordeons = {
  initAccordeons: () => {
    try {
        const Default = {
            alwaysOpen: false,
            activeClasses: 'bg-earth-dark/20 dark:bg-slate-800 text-emerald-500',
            inactiveClasses: 'text-dark dark:text-white',
            onOpen: () => { },
            onClose: () => { },
            onToggle: () => { }
        }

        class Accordion {
            constructor(items = [], options = {}) {
                this._items = items
                this._options = { ...Default, ...options }
                this._init()
            }

            _init() {
                if (this._items.length) {
                    // show accordion item based on click
                    this._items.map(item => {

                        if (item.active) {
                            this.open(item.id)
                        }

                        item.triggerEl.addEventListener('click', () => {
                            this.toggle(item.id)
                        })
                    })
                }
            }

            getItem(id) {
                return this._items.filter(item => item.id === id)[0]
            }

            open(id) {
                const item = this.getItem(id)

                // don't hide other accordions if always open
                if (!this._options.alwaysOpen) {
                    this._items.map(i => {
                        if (i !== item) {
                            i.triggerEl.classList.remove(...this._options.activeClasses.split(" "))
                            i.triggerEl.classList.add(...this._options.inactiveClasses.split(" "))
                            i.targetEl.classList.add('hidden')
                            i.triggerEl.setAttribute('aria-expanded', false)
                            i.active = false

                            // rotate icon if set
                            if (i.iconEl) {
                                i.iconEl.classList.remove('rotate-180')
                            }
                        }
                    })
                }

                // show active item
                item.triggerEl.classList.add(...this._options.activeClasses.split(" "))
                item.triggerEl.classList.remove(...this._options.inactiveClasses.split(" "))
                item.triggerEl.setAttribute('aria-expanded', true)
                item.targetEl.classList.remove('hidden')
                item.active = true

                // rotate icon if set
                if (item.iconEl) {
                    item.iconEl.classList.add('rotate-180')
                }

                // callback function
                this._options.onOpen(this, item)
            }

            toggle(id) {
                const item = this.getItem(id)

                if (item.active) {
                    this.close(id)
                } else {
                    this.open(id)
                }

                // callback function
                this._options.onToggle(this, item)
            }

            close(id) {
                const item = this.getItem(id)

                item.triggerEl.classList.remove(...this._options.activeClasses.split(" "))
                item.triggerEl.classList.add(...this._options.inactiveClasses.split(" "))
                item.targetEl.classList.add('hidden')
                item.triggerEl.setAttribute('aria-expanded', false)
                item.active = false

                // rotate icon if set
                if (item.iconEl) {
                    item.iconEl.classList.remove('rotate-180')
                }

                // callback function
                this._options.onClose(this, item)
            }

        }

        window.Accordion = Accordion;
        //document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('[data-accordion]').forEach(accordionEl => {

                const alwaysOpen = accordionEl.getAttribute('data-accordion')
                const activeClasses = accordionEl.getAttribute('data-active-classes')
                const inactiveClasses = accordionEl.getAttribute('data-inactive-classes')

                const items = []
                accordionEl.querySelectorAll('[data-accordion-target]').forEach(el => {
                    const item = {
                        id: el.getAttribute('data-accordion-target'),
                        triggerEl: el,
                        targetEl: document.querySelector(el.getAttribute('data-accordion-target')),
                        iconEl: el.querySelector('[data-accordion-icon]'),
                        active: el.getAttribute('aria-expanded') === 'true' ? true : false
                    }
                    items.push(item)
                })

                new Accordion(items, {
                    alwaysOpen: alwaysOpen === 'open' ? true : false,
                    activeClasses: activeClasses ? activeClasses : Default.activeClasses,
                    inactiveClasses: inactiveClasses ? inactiveClasses : Default.inactiveClasses
                })
            })
        //})
    } catch (error) {
      console.log("Something went wrong initializing accordeons");
    }
  }
}

//=========================================//
/*      06) Choices Js                    */
//=========================================//

var choiceSelect = {
  initChoices: (id) => {
    try {
        var element = document.getElementById(id);
        if(element) {
          var selectObject = new Choices(`#${id}`,  { allowHTML: true });
          return selectObject;
        }
    } catch (error) {
      console.log("Choice select error:",error);
    }
    return null;
    /*
    //for buy
    try {
        var choicescatagory = new Choices('#choices-catagory-buy',  { allowHTML: true });
        var choicesmin = document.getElementById('choices-min-price-buy');
        var choicesmax = document.getElementById('choices-max-price-buy');
        if(choicesmin){
            var choicesmins = new Choices('#choices-min-price-buy');
        }
        if(choicesmax){
            var choicesmaxs = new Choices('#choices-max-price-buy');
        }
    } catch (error) {
    }

    //for sell
    try {
        var choicescatagory = new Choices('#choices-catagory-sell',  { allowHTML: true });
        var choicesmin = document.getElementById('choices-min-price-sell');
        var choicesmax = document.getElementById('choices-max-price-sell');
        if(choicesmin){
            var choicesmins = new Choices('#choices-min-price-sell');
        }
        if(choicesmax){
            var choicesmaxs = new Choices('#choices-max-price-sell');
        }
    } catch (error) {
    }

    //for rent
    try {
        var choicescatagory = new Choices('#choices-catagory-rent',  { allowHTML: true });
        var choicesmin = document.getElementById('choices-min-price-rent');
        var choicesmax = document.getElementById('choices-max-price-rent');
        if(choicesmin){
            var choicesmins = new Choices('#choices-min-price-rent');
        }
        if(choicesmax){
            var choicesmaxs = new Choices('#choices-max-price-rent');
        }
    } catch (error) {
    }*/
  }
};

//=========================================//
/*/*            07) Maintenance js         */
//=========================================//

try {
    if(document.getElementById("maintenance")){
        var seconds = 3599;
        function secondPassed() {
            var minutes = Math.round((seconds - 30) / 60);
            var remainingSeconds = seconds % 60;
            if (remainingSeconds < 10) {
                remainingSeconds = "0" + remainingSeconds;
            }
            document.getElementById('maintenance').innerHTML = minutes + ":" + remainingSeconds;
            if (seconds == 0) {
                clearInterval(countdownTimer);
                document.getElementById('maintenance').innerHTML = "Buzz Buzz";
            } else {
                seconds--;
            }
        }
        var countdownTimer = setInterval('secondPassed()', 1000);
    }
} catch (err) {

}


//=========================================//
/*            08) Countdown Js             */
//=========================================//
try {
    if(document.getElementById("days")){
        // The data/time we want to countdown to
        var eventCountDown = new Date("June 25, 2023 16:37:52").getTime();

        // Run myfunc every second
        var myfunc = setInterval(function () {

            var now = new Date().getTime();
            var timeleft = eventCountDown - now;

            // Calculating the days, hours, minutes and seconds left
            var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
            var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

            // Result is output to the specific element
            document.getElementById("days").innerHTML = days + "<p class='count-head'>Days</p> "
            document.getElementById("hours").innerHTML = hours + "<p class='count-head'>Hours</p> "
            document.getElementById("mins").innerHTML = minutes + "<p class='count-head'>Mins</p> "
            document.getElementById("secs").innerHTML = seconds + "<p class='count-head'>Secs</p> "

            // Display the message when countdown is over
            if (timeleft < 0) {
                clearInterval(myfunc);
                document.getElementById("days").innerHTML = ""
                document.getElementById("hours").innerHTML = ""
                document.getElementById("mins").innerHTML = ""
                document.getElementById("secs").innerHTML = ""
                document.getElementById("end").innerHTML = "00:00:00:00";
            }
        }, 1000);
    }
} catch (err) {

}

//=========================================//
/*            09) Upload Profile           */
//=========================================//
try {
    var loadFile = function (event) {

        var image = document.getElementById(event.target.name);
        image.src = URL.createObjectURL(event.target.files[0]);
    };

} catch (error) {

}
